import { Component, OnInit, Inject, HostListener, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AbstractControl, FormControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { ThemeService } from '@app/core/services/theme.service';

export function phoneNumberValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const phone = control.value;
    const phonePattern =
      /^(\+?\d{1,3})?[-.\s]?\(?\d{1,4}\)?[-.\s]?\d{1,4}[-.\s]?\d{1,9}$/;
    return phone && !phonePattern.test(phone) ? { invalidPhoneNumber: true } : null;
  };
}

@Component({
    selector: 'app-send-phone-dialog',
    templateUrl: './send-phone-dialog.component.html',
    styleUrls: ['./send-phone-dialog.component.scss'],
    standalone: false
})
export class SendPhoneDialogComponent implements OnInit {
  private destroyRef = inject(DestroyRef);
  phoneCtrl = new FormControl('', [phoneNumberValidator()]);
  separatorKeysCodes: number[] = [ENTER, COMMA];
  infoIcon: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: {
      chips: Array<string>,
      removable: boolean | true,
      cancelText: string | null,
      confirmText: string | null,
      message: string | null,
      extra_message: string | null,
      title: string | null,
    },
    private dialogRef: MatDialogRef<SendPhoneDialogComponent>,
    private themeService: ThemeService,
  ) {
    const theme = this.themeService.getCurrentTheme();
    this.setThemedIcons(theme);
  }

  ngOnInit(): void {
    this.themeService.theme$.pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((theme: string) => {
      this.setThemedIcons(theme);
    });
  }

  private setThemedIcons(theme: string): void {
    this.infoIcon = `assets/svg/themed/${theme}/info-icon.svg`;
  }

  public cancel() {
    this.close(false);
  }

  public close(value) {
      this.dialogRef.close(value);
  }

  public confirm() {
    if (this.phoneCtrl.value && this.phoneCtrl.valid) {
      this.add(this.phoneCtrl.value);
    } else if (this.phoneCtrl.value && !this.phoneCtrl.valid) {
      return;
    }
    this.close(this.data);
  }

  remove(chip: string): void {
    const index = this.data.chips.indexOf(chip);

    if (index >= 0) {
      this.data.chips.splice(index, 1);
      this.phoneCtrl.updateValueAndValidity();
    }
  }

  @HostListener('keydown.esc')
  public onEsc() {
    this.close(false);
  }

  add(value: string): void {
    if (this.phoneCtrl.valid) {
      this.data.chips.push(value.trim());
      this.phoneCtrl.setValue(null);
    }
  }
}
